import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const ASZF = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Back Button */}
        <Link 
          to="/" 
          className="inline-flex items-center text-[#00BCD4] hover:text-[#FFA726] mb-6 transition-colors"
        >
          <ArrowLeft className="w-5 h-5 mr-2" />
          Vissza a főoldalra
        </Link>

        {/* Header */}
        <div className="bg-white rounded-lg shadow-sm p-8 mb-6">
          <h1 className="text-4xl font-bold mb-2">
            <span className="text-[#00BCD4]">Általános Szerződési</span>
            <span className="text-[#FFA726]"> Feltételek</span>
          </h1>
          <p className="text-gray-600">ÁSZF</p>
        </div>

        {/* Content */}
        <div className="bg-white rounded-lg shadow-sm p-8 prose prose-lg max-w-none">
          <h2>1. Szolgáltató adatai</h2>
          <p>
            <strong>Név:</strong> Horváth Attila EV<br />
            <strong>Székhely:</strong> 2315 Szigethalom, Széchenyi u. 44<br />
            <strong>Adószám:</strong> 56589119-1-33<br />
            <strong>Email:</strong> maszek.ah37@gmail.com<br />
            <strong>Telefonszám:</strong> +36 30 951 7159
          </p>

          <h2>2. A szolgáltatás tárgya</h2>
          <p>
            A szolgáltató a weboldalon keresztül ételrendelési lehetőséget biztosít a 
            felhasználók számára házhozszállítással vagy az aktuálisan megjelölt egyéb 
            átvételi módokkal.
          </p>

          <h2>3. Rendelés menete</h2>
          <p>
            A vásárló a weboldalon kiválasztja a kívánt termékeket, azokat kosárba helyezi, 
            megadja a szükséges adatokat, kiválasztja a fizetési módot, majd leadja a rendelést.
          </p>
          <p>
            <strong>A rendelés leadása fizetési kötelezettséget keletkeztet.</strong>
          </p>

          <h2>4. Kiszállítási területek</h2>
          <p>A szolgáltató az alábbi településekre vállal kiszállítást:</p>
          <ul>
            <li>Szigethalom</li>
            <li>Szigetszentmiklós</li>
            <li>Tököl</li>
            <li>Dunaharaszti</li>
            <li>Dunavarsány</li>
            <li>Taksony</li>
            <li>Halásztelek</li>
          </ul>

          <h2>5. Kiszállítási idő</h2>
          <p>
            A várható kiszállítási idő általában <strong>30-60 perc</strong>. 
            A megadott idő tájékoztató jellegű, a tényleges kiszállítási idő forgalmi, 
            időjárási, technikai vagy egyéb körülmények miatt eltérhet.
          </p>

          <h2>6. Minimum rendelési összeg</h2>
          <p>
            A szolgáltatónál jelenleg <strong>nincs minimum rendelési összeg</strong>.
          </p>

          <h2>7. Fizetési módok</h2>
          <p>A weboldalon leadott rendelések esetén az alábbi fizetési módok érhetők el:</p>
          <ul>
            <li>Bankkártya</li>
            <li>Készpénz</li>
            <li>OTP SZÉP kártya</li>
          </ul>

          <h2>8. Számlázás</h2>
          <p>
            <strong>A számlázás kizárólag helyszínen történik.</strong>
          </p>

          <h2>9. Elállási jog</h2>
          <p>
            A megrendelt ételek <strong>romlandó terméknek</strong> minősülnek, 
            ezért a fogyasztót a 45/2014. (II. 26.) Korm. rendelet alapján 
            <strong>nem illeti meg a 14 napos indokolás nélküli elállási jog</strong>.
          </p>

          <h2>10. Felelősség</h2>
          <p>
            A szolgáltató nem vállal felelősséget a rajta kívül álló okokból eredő 
            késedelemért, hibás teljesítésért vagy szolgáltatáskimaradásért, különösen 
            vis maior, technikai meghibásodás, közlekedési akadály vagy harmadik fél 
            hibája esetén.
          </p>

          <h2>11. Panaszkezelés</h2>
          <p>
            A vásárló panaszait az alábbi email címen jelentheti be:<br />
            <a href="mailto:rendeles@boldogbufe.hu" className="text-[#00BCD4] hover:text-[#FFA726]">
              rendeles@boldogbufe.hu
            </a>
          </p>

          <h2>12. Záró rendelkezések</h2>
          <p>
            A szolgáltató jogosult a jelen ÁSZF módosítására. 
            Az aktuális verzió mindig a weboldalon érhető el.
          </p>

          <div className="mt-8 pt-6 border-t border-gray-200">
            <p className="text-sm text-gray-600">
              <strong>Kapcsolat:</strong><br />
              Horváth Attila EV<br />
              2315 Szigethalom, Széchenyi u. 44<br />
              Email: maszek.ah37@gmail.com<br />
              Telefon: +36 30 951 7159
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ASZF;
